<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">طلبات استرداد الحسابات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">طلبات استرداد الحسابات</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header"><div class="card-title">طلبات استرداد الحسابات</div></div>

              <!-- Filters -->
              <div class="card-body border-bottom pb-3">
                <div class="row g-2">
                  <div class="col-12 col-sm-4">
                    <input v-model="filterMobile" type="text" class="form-control" placeholder="بحث برقم الجوال" @keyup.enter="search()" />
                  </div>
                  <div class="col-12 col-sm-3">
                    <select v-model="filterSection" class="form-control">
                      <option value="">كل الأقسام</option>
                      <option value="users">عملاء</option>
                      <option value="providers">مزودو خدمة</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-3">
                    <select v-model="filterStatus" class="form-control">
                      <option value="">كل الحالات</option>
                      <option value="new">جديد</option>
                      <option value="approved">موافق عليه</option>
                      <option value="rejected">مرفوض</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-2">
                    <button class="btn btn-primary w-100" @click="search()">بحث</button>
                  </div>
                </div>
              </div>

              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>رقم الجوال</th>
                            <th>القسم</th>
                            <th>الحالة</th>
                            <th>تاريخ الطلب</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.mobile }}</td>
                            <td>{{ row.section === 'users' ? 'عميل' : 'مزود خدمة' }}</td>
                            <td>
                              <span :class="statusBadge(row.status)">{{ statusTranslate[row.status] }}</span>
                            </td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/restoreAccounts/update/${row.id}`" class="btn btn-light btn-sm">
                                <i v-if="checkAccess('restore_accounts_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                            </td>
                          </tr>
                          <tr v-if="rows.length === 0">
                            <td colspan="6" class="text-center text-muted">لا توجد طلبات</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item">
                        <a class="page-link" href="#" @click.prevent="prevPage()">السابق</a>
                      </li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item">
                        <a class="page-link" href="#" @click.prevent="nextPage()">التالي</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';

export default {
  name: 'RestoreAccountsList',
  data() {
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      pages: [],
      currentPage: 1,
      filterMobile: this.$route.query.mobile || '',
      filterSection: '',
      filterStatus: '',
      statusTranslate: {
        new: 'جديد',
        approved: 'موافق عليه',
        rejected: 'مرفوض',
      },
    };
  },
  methods: {
    checkAccess,
    statusBadge(status) {
      return {
        'badge': true,
        'bg-warning text-dark': status === 'new',
        'bg-success': status === 'approved',
        'bg-danger': status === 'rejected',
      };
    },
    getRows() {
      this.mainLoading = true;
      const params = { page: this.currentPage };
      if (this.filterMobile) params.mobile = this.filterMobile;
      if (this.filterSection) params.section = this.filterSection;
      if (this.filterStatus) params.status = this.filterStatus;

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.filterMobile ? { mobile: this.filterMobile } : {}),
        ...(this.filterSection ? { section: this.filterSection } : {}),
        ...(this.filterStatus ? { status: this.filterStatus } : {}),
      }}).catch(() => {});

      this.$http.get('/api/admin/restoreAccounts/list', { params }).then(({ data }) => {
        this.rows = data.rows;
        this.pages = data.pages;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
      });
    },
    resetFilter(){
      this.filterMobile = '';
      this.filterSection = '';
      this.filterStatus = '';
      this.currentPage = 1;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },

        search() {
      this.currentPage = 1;
      this.getRows();
    },
    nextPage() {
      this.currentPage += 1;
      this.getRows();
    },
    prevPage() {
      this.currentPage -= 1;
      this.getRows();
    },
    goToPage(p) {
      this.currentPage = p;
      this.getRows();
    },
  },
  created() {
    this.getRows();
  },
};
</script>